const permissions = {
  schedule: 'SC001',
  addSchedule: 'SC002',
  editSchedule: 'SC003',
  deleteSchedule: 'SC004'
};

export default permissions;
